export function resolveAppMountBase(pathname?: string): string {
  // Default to the live URL so callers that don't thread `pathname` through
  // still resolve the app's mount prefix. Without this, a mounted deploy
  // (/a/dev/{app}, /a/{app}, /a/branch/…) falls back to '' and fires requests
  // at the DOMAIN ROOT — e.g. a nested CC sub-app's /auth/* link calls hit the
  // outer platform instead of itself, surfacing as "not found".
  const path = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '/')

  const branchMatch = path.match(/^\/a\/branch\/[^/]+\/[^/]+/)
  if (branchMatch) {
    return branchMatch[0]
  }

  const devMatch = path.match(/^\/a\/dev\/[^/]+/)
  if (devMatch) {
    return devMatch[0]
  }

  const prodMatch = path.match(/^\/a\/(?!dev(?:\/|$)|branch(?:\/|$))[^/]+/)
  if (prodMatch) {
    return prodMatch[0]
  }

  return ''
}

export function resolveApiBase(pathname?: string): string {
  const base = resolveAppMountBase(pathname)
  return base ? `${base}/api` : '/api'
}

export function withMountBase(path: string, pathname?: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`
  const base = resolveAppMountBase(pathname)
  return base ? `${base}${normalized}` : normalized
}
